import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { DatesService } from "src/app/shared/services/dates.service";
import { ParametroEmpresaService } from "src/app/services/parametro-empresa.service";
import { SaldoDocumentoService } from 'src/app/services/saldo-documento.service';
import { ToastService } from 'ng-uikit-pro-standard';
import * as _ from "lodash";

@Component({
  selector: 'app-modal-seleccion-documento-ajuste',
  templateUrl: './modal-seleccion-documento-ajuste.component.html',
  styleUrls: ['./modal-seleccion-documento-ajuste.component.scss'],
  providers: [SecurityService],
})
export class ModalSeleccionDocumentoAjusteComponent implements OnInit {

  // Input
  @Input() tipo_dte_codigo: number = 0
  @Input() es_nc: boolean = false
  @Input() es_nd: boolean = false
  @Input() tipo_ncnd: number = 0

  // Output
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild('seleccionarDocumento', { static: true }) seleccionarDocumentoModal: ModalDirective;

  // Form
  formData: FormGroup

  // Data
  private rutEmpresa: Number
  private sucursalEmpresa: Number
  private rutUsuario: Number
  listaMovimientosAll: Array<any> = null
  listaMovimientos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  busquedaIniciada: boolean = false
  loading: boolean = false
  processing: boolean = false
  clienteSeleccionado: any = null
  // Utils
  private log: any
  proveedorRut: number;
  resultData: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private datesService: DatesService,
    private parametroEmpresaService: ParametroEmpresaService,
    private toastService: ToastService,
    private saldoDocumentoService: SaldoDocumentoService,
  ) {
    this.log = this.clog.log('MODAL-SELECCION-FACTURA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario())

    this.paginationContext.RecordsByPage = 10

    this.createForm()
    this.setParametroMontoAjuste()
  }

  createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData = this.fb.group({
      monto: [null, [Validators.required]],
      // rut: [null],
      // fechaDesde: [initDate, [Validators.required]],
      // fechaHasta: [currentDate, [Validators.required]],
      // nombre: [null]
    });
  }
  setParametroMontoAjuste() {
    this.parametroEmpresaService.obtenerMontoSencillo(this.rutEmpresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.formData.get("monto").setValue(respuesta.valor_numerico)
      this.log('Monto', this.formData.get('monto').value)
    })
  }

  show(cleanData: Boolean = true) {
    if (cleanData) {
      this.cleanAll()
    }
    this.seleccionarDocumentoModal.show();
  }

  load(cliente: any) {
    //this.proveedorRut =  this.rutService.QuitarDV(this.rutService.Limpiar(rutProveedor));
    this.clienteSeleccionado = cliente
    this.seleccionarDocumentoModal.show();
    this.buscarTodos(true)
    // this.cleanAll()
  }

  hide() {
    this.seleccionarDocumentoModal.hide();
  }

  private cleanAll() {
    this.cleanFormData()
    this.cleanResultData()
  }

  private cleanFormData() {
    this.formData.reset()
    this.formData.markAsPristine()
    this.formData.markAsUntouched()

    this.initializeFormData()
  }

  private cleanResultData() {
    this.busquedaIniciada = false
    this.listaMovimientos = []
    this.listaMovimientosAll = []
    this.loading = false
  }

  private initializeFormData() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData.get("folio").setValue(null)
    this.formData.get("rut").setValue(null)
    this.formData.get("fechaDesde").setValue(initDate)
    this.formData.get("fechaHasta").setValue(currentDate)
    this.formData.get("nombre").setValue(null)
  }

  /********* OPERATIONS *********/
  buscarTodos(fromStartPage: Boolean = false) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1

    // limpiar datos antes de desplegar
    this.cleanResultData()
    const inputParams = this.createInputParamsBuscarTodos()
    this.loading = true
    this.executeQueryBuscarTodos(inputParams, (result) => this.renderQueryResults(result))
  }

  private createInputParamsBuscarTodos() {
    const { folio, rut, nombre, monto } = this.formData.value
    // let rutSinDv = 0;
    // if (rut)
    //   rutSinDv = this.rutService.QuitarDV(this.rutService.Limpiar(rut))

    let payload: any =
    {
      entidad: {
        //rut_emisor: this.proveedorRut,
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        cliente_proveedor_rut: this.clienteSeleccionado === null ? 0 : this.clienteSeleccionado.rut,
        monto: monto,
        //folio: this.formData.get('folio').value,
        //cliente_proveedor_nombre: this.formData.get('nombre').value != null ? this.formData.get('nombre').value : "" ,
        // rut_cliente_proveedor: this.formData.get('rut').value,
        // fecha_desde: this.formData.get('fechaDesde').value,
        // fecha_hasta: this.formData.get('fechaHasta').value,
        // tipo_ncnd_codigo: this.tipo_ncnd
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }
    return payload
  }

  private renderQueryResults(result: QueryResult) {
    const { registros, paginaActual, totalPaginas, totalRegistros } = result
    this.log('registros', registros, result)
    this.listaMovimientosAll = registros
    this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
    this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
    this.paginationContext.CurrentPage = paginaActual
    this.listaMovimientosAll.forEach((element, index) => {
      // delete element.__typename
      element.rutFormato = this.rutService.AgregarDV(element.cliente_proveedor_rut)
      element.additionalInfo = {}
      this.cleanIncomingData(element)
      element.additionalInfo.index = index
      element.seleccion = false
    });
    this.busquedaIniciada = true
    this.showPage(this.paginationContext.CurrentPage)
    this.loading = false
    this.checkAllChangeStart({ checked: true });
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  private cleanIncomingData(register: any) {
    delete register.__typename
  }

  private executeQueryBuscarTodos(inputParams: any, callback: Function) {
    const self = this
    this.log('inputParams', JSON.stringify(inputParams))
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          saldo_documento {
            obtenerDocumentoAjuste(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  rut_emisor
                  sucursal_codigo
                  cliente_proveedor_rut
                  razonSocialCliente
                  documento
                  folio
                  protesto_cheque_codigo
                  reversa_pago_codigo
                  faltante_excedentes_codigo
                  tipo_dte_codigo
                  fecha_emision
                  fechaVencimientoDocto
                  monto
                  abono
                  saldo
                  recorrido_codigo
                  estado_recorrido
                }
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.saldo_documento.obtenerDocumentoAjuste
        const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
        if (!ok) {
          self.messageRendererService.showErrors(mensajes)
          callback(new QueryResult(null, 0, 0, 0))
          this.loading = false
          return
        }

        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta

        // callback({ registros, paginaActual, totalPaginas, totalRegistros })
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros))
      }
    );
  }



  /********* OPERATIONS *********/
  checkAllChange({ checked }) {

    this.listaMovimientosAll.forEach(mov => {
      // Solo seleccionar si puede ser ajustado
      if (checked && this.puedeAjustar(mov)) {
        mov.seleccion = checked
        mov.additionalInfo.checked = checked
      } else {
        mov.seleccion = false
        mov.additionalInfo.checked = false
      }
    })
    this.listaMovimientos.forEach(mov => {
      // Solo seleccionar si puede ser ajustado
      if (checked && this.puedeAjustar(mov)) {
        mov.seleccion = checked
        mov.additionalInfo.checked = checked
      } else {
        mov.seleccion = false
        mov.additionalInfo.checked = false
      }
    })
    //this.docSeleccionado = 0
    //this.cantidadSeleccionada()
  }

  checkAllChangeStart({ checked }) {

    this.listaMovimientosAll.forEach(mov => {
      // Solo seleccionar si puede ser ajustado
      if (checked && this.puedeAjustar(mov)) {
        mov.seleccion = checked
        mov.additionalInfo.checked = checked
      } else {
        mov.seleccion = false
        mov.additionalInfo.checked = false
      }
    })
    this.listaMovimientos.forEach(mov => {
      // Solo seleccionar si puede ser ajustado
      if (checked && this.puedeAjustar(mov)) {
        mov.seleccion = checked
        mov.additionalInfo.checked = checked
      } else {
        mov.seleccion = false
        mov.additionalInfo.checked = false
      }
    })
    //this.docSeleccionado = 0
    //this.cantidadSeleccionada()
  }

  puedeAjustar(doc: any): boolean {
    // Si estado_recorrido es "despachado" y tiene recorrido, no se puede ajustar
    if (doc.estado_recorrido && doc.estado_recorrido.toLowerCase() === 'despachado' && doc.recorrido_codigo && doc.recorrido_codigo > 0) {
      return false
    }
    return true
  }

  checkDetalle({ index, checked }) {
    const selectedMain: any = this.listaMovimientosAll.filter(p => p.additionalInfo.index === index)[0]
    selectedMain.seleccion = !checked
    selectedMain.additionalInfo.checked = !checked

    const selected = this.listaMovimientos.filter(p => p.additionalInfo.index === index)[0]
    selected.seleccion = !checked
    selected.additionalInfo.checked = !checked
    // this.docSeleccionado = 0
    // this.cantidadSeleccionada()
  }

  ajustar() {
    const selected = (_.cloneDeep(this.listaMovimientosAll)).filter(mov => mov.seleccion)
    if (selected.length === 0) {
      this.toastService.error('Seleccione registro(s)')
      return
    }

    selected.forEach(mov => {
      delete mov.additionalInfo
      delete mov.__typename
      delete mov.rutFormato
    });

    const { documento, copia_cedible, enviar_pdf, enviar_xml, orden_envio } = this.formData.value
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        rut_usuario: this.rutUsuario,
        listaDocumentos: selected
      }
    }
    this.processing = true
    this.log('inputParams', JSON.stringify(inputParams))

    this.saldoDocumentoService.AjusteSecilloCuentaCorrienteCliente(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.messageRendererService.showInfoMessages(mensajes)
        this.processing = false
        return
      }

      // const { registros, totalPaginas, totalRegistros } = respuesta
      // const index: string = this.depositoDocumentoService.guardarPayload({ registros, totalPaginas, totalRegistros })
      this.processing = false
      this.toastService.success('Operación exitosa')
      this.buscarTodos(true)
    })
  }

}
